export default {
  metadata: {
    version: '1.0.0',
    id: 'desktop-bottom-sheet-1.0.0',
    name: 'JDSDesktopBottomSheet',
    platform: 'web'
  },
  hierarchy: {
    popup: [
      {
        'popup-container': ['jds_desktop_bottom_sheet_internal']
      }
    ]
  },
  base: {
    popup: {
      priority: 60,
      passive: true
    },
    'popup-container': {
      show: true,
      'flex-direction': '{d_0}',
      'justify-content': '{d_1}',
      'align-items': '{d_2}',
      'background-color': '{d_3}',
      size: '{d_4}',
      'enter-animation-name': 'fadeIn',
      'exit-animation-name': 'fadeOut',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500,
      'padding-right': 90,
      opacity: '{opacity.invisible}',
      transition: {
        property: ['opacity'],
        duration: '{medium}',
        'timing-function': '{easeEntrance}'
      }
    },
    jds_desktop_bottom_sheet_internal: {
      close: true
    }
  },
  variant: {
    kind: {
      passive: {
        popup: {
          passive: true,
          'background-color': 'transparent'
        },
        'popup-container': {
          'background-color': 'transparent'
        }
      }
    },
    isCustom: {
      true: {
        jds_desktop_bottom_sheet_internal: {
          isCustom: true
        }
      }
    },
    close: {
      false: {
        'popup-container': {
          opacity: '{opacity.enabled}',
          transition: {
            'timing-function': '{easeExit}'
          }
        },
        jds_desktop_bottom_sheet_internal: {
          close: false
        }
      }
    }
  },
  combination: [
    {
      false: {
        overlay: {
          popup: {
            passive: false
          }
        }
      }
    }
  ],
  combination_config: [['close', 'kind']],
  api: {
    config: {
      kind: {
        values: ['overlay', 'passive']
      },
      controlType: {
        values: ['normal', 'stepper']
      },
      isCustom: {
        values: [false, true]
      },
      close: {
        values: [true, false]
      },
      primaryCtaDisabled: {
        values: [false, true]
      },
      secondaryCtaDisabled: {
        values: [false, true]
      }
    },
    data: {
      jds_desktop_bottom_sheet_internal: {
        height: {
          type: 'number',
          name: 'height'
        },
        title: {
          type: 'string',
          name: 'title'
        },
        description: {
          type: 'string',
          name: 'description'
        },
        primaryCTA: {
          type: 'string',
          name: 'primaryCTA'
        },
        secondaryCTA: {
          type: 'string',
          name: 'secondaryCTA'
        },
        step_label: {
          type: 'string',
          name: 'label'
        },
        children: {
          name: 'children',
          type: 'slot'
        }
      }
    },
    events: {
      popup: {
        onClick: 'onClose'
      },
      jds_desktop_bottom_sheet_internal: {
        onBottomSheetClick: '_onBottomSheetClick',
        onClose: 'onClose',
        onCancel: 'onCancel',
        onPrimaryClick: 'onPrimaryClick',
        onSecondaryClick: 'onSecondaryClick',
        onBack: 'onBack'
      }
    },
    a11y: {
      jds_desktop_bottom_sheet_internal: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          cancelButtonAriaLabel: 'cancelButtonAriaLabel',
          backButtonAriaLabel: 'backButtonAriaLabel',
          primaryCtaAriaLabel: 'primaryCtaAriaLabel',
          primaryCtaAriaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          },
          secondaryCtaAriaLabel: 'secondaryCtaAriaLabel',
          secondaryCtaAriaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
